import { Link } from 'react-router-dom';

export default function CTABanner() {
  return (
    <section className="py-20 bg-stone-950">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-5">
          Ready to generate ads that
          <br />
          <span className="bg-gradient-to-r from-orange-400 to-amber-300 bg-clip-text text-transparent">actually convert?</span>
        </h2>
        <p className="text-lg text-white/60 mb-10 max-w-xl mx-auto">
          Join 3,200+ businesses using AdForge to write better ads in minutes. Start free — no credit card required.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/quick-start"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-amber-400 text-white font-bold text-base px-8 py-4 rounded-xl hover:from-orange-600 hover:to-amber-500 transition-all duration-200 whitespace-nowrap"
          >
            <i className="ri-flashlight-fill" />
            Generate My Ad - Free
          </Link>
          <Link
            to="/pricing"
            className="inline-flex items-center gap-2 bg-white/10 border border-white/20 text-white font-semibold text-base px-8 py-4 rounded-xl hover:bg-white/20 transition-all duration-200 whitespace-nowrap"
          >
            View Pricing
          </Link>
        </div>
        <p className="mt-6 text-sm text-white/40">Free plan includes 25 credits/month · No credit card required · Cancel anytime</p>
      </div>
    </section>
  );
}
